module.exports = __webpack_public_path__ + "img/rejected-symbol.32489120.svg";